import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import MultiSelectAutocomplete from "./base/MultiSelectAutoComplete.js";

const SelectMultipleUsersByAgent = ({ agents, users, loading, error, selectedUsers, setSelectedUsers }) => {
  const hasAgents = !!agents?.length;

  return (
    <MultiSelectAutocomplete
      options={users}
      selected={selectedUsers}
      onChange={setSelectedUsers}
      label={<FormattedMessage id="app.customers" />}
      error={error ? error : !hasAgents ? "app.report.agent.select" : null}
      loading={loading}
    />
  );
};

export default injectIntl(SelectMultipleUsersByAgent);
